import { render, staticRenderFns } from "./tdUserNameLink.vue?vue&type=template&id=438bb6f4&scoped=true"
import script from "./tdUserNameLink.vue?vue&type=script&lang=js"
export * from "./tdUserNameLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "438bb6f4",
  null
  
)

export default component.exports